import script from "./NewProjectPage.vue?vue&type=script&setup=true&lang=js"
export * from "./NewProjectPage.vue?vue&type=script&setup=true&lang=js"

import "./NewProjectPage.vue?vue&type=style&index=0&id=6ba7958d&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ba7958d"]])

export default __exports__